"use strict";

function getCookie(name) {
    var match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
    return match ? match[1] : "";
}

module.exports = function () {
    var pageEl = document.querySelector(".page[data-gender-cult-category]");
    if (pageEl) {
        var genderCultCategory = pageEl.getAttribute("data-gender-cult-category");
        if (genderCultCategory && getCookie("lastGenderCult") !== genderCultCategory) {
            var maxAge = 365 * 24 * 60 * 60;
            document.cookie = "lastGenderCult=" + genderCultCategory + ";path=/;max-age=" + maxAge;
        }
    }
};
